import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

import App from './App.vue'
import router from './router'

// Styles
import './assets/styles/main.css'

// Locales
import ru from './locales/ru.json'
import en from './locales/en.json'

// Create Vue app
const app = createApp(App)

// Pinia (State Management)
const pinia = createPinia()
app.use(pinia)

// Vue I18n
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'ru',
  fallbackLocale: 'en',
  messages: {
    ru,
    en,
  },
})
app.use(i18n)

// Router
app.use(router)

// Mount app
app.mount('#app')
